import { createAction, props } from '@ngrx/store';
import { KeycloakProfile } from 'keycloak-js';

export const setUser = createAction(
  '[User] Set User',
  props<{ user: KeycloakProfile }>()
);
